import React, { FC, FormEvent, useState } from 'react'
import { CustomLayer, PointIcons, PointStyle } from 'models/custom-layer'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { ColorPicker } from 'components/ColorPicker'
import { RadioGroup } from 'components/RadioButton'
import { PointStyleRadio } from '../PointStyleRadio'
import { IconUtils } from 'utils/icon'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import styles from '../../CustomLayerStylesDialog.module.scss'

type CustomLayerPointProps = {
  customLayer: CustomLayer
  onSubmit: (style: PointStyle) => void
  status: string
}

const POINT_ICONS = [
  PointIcons.Circle,
  PointIcons.Diamond,
  PointIcons.Factory,
  PointIcons.Flag,
  PointIcons.Heart,
  PointIcons.Home,
  PointIcons.Pin,
  PointIcons.Square,
  PointIcons.Star,
]

export const CustomLayerPoint: FC<CustomLayerPointProps> = ({
  customLayer,
  onSubmit,
  status = 'idle',
}) => {
  const { t } = useTranslation()
  const [style, setStyle] = useState(customLayer.viz as PointStyle)

  const onFormSubmit = (event: FormEvent) => {
    event.preventDefault()
    onSubmit(style)
  }

  return (
    <form onSubmit={onFormSubmit}>
      <Stack space="medium">
        <Flex align="center">
          <Text component="span" weight="strong" className={styles.label}>
            {t('layer_style_dialog.form.color')}
          </Text>
          <ColorPicker
            value={style.paint['icon-color']}
            onChange={(color) =>
              setStyle({
                ...style,
                paint: { 'icon-color': color },
              })
            }
          />
        </Flex>

        <Flex align="center">
          <Text component="span" weight="strong" className={styles.label}>
            {t('layer_style_dialog.form.icon')}
          </Text>
          <RadioGroup
            value={style.layout['icon-image']}
            onChange={(value) =>
              setStyle({ ...style, layout: { 'icon-image': value as PointIcons } })
            }
          >
            {POINT_ICONS.map((icon) => (
              <PointStyleRadio
                key={icon}
                icon={IconUtils.getIconFromName(icon)}
                value={icon}
                label={t(`layer_style_dialog.icons.${icon}`)}
                style={{
                  color: style.paint['icon-color'],
                }}
              />
            ))}
          </RadioGroup>
        </Flex>

        <Button type="submit" full loading={status === 'loading'}>
          {t('layer_style_dialog.cta')}
        </Button>
      </Stack>
    </form>
  )
}

/* POLYGON
<Flex align="center">
            <Text component="span" weight="strong" className={styles.label}>
              {t('layer_style_dialog.form.stroke_width')}
            </Text>
            <Select
              options={STROKE_WIDTH_OPTIONS}
              value={buildSimpleOption(strokeWidth)}
              onChange={(option) =>
                setStrokeWidth(parseInt(option!.value! as string) as StrokeWidth)
              }
              className={styles.select}
            />
          </Flex>
        )}
        */
